/**
 * Price math shared by `CartSummary` and `CartLineItem`.
 */

/**
 * Totals a cart's line items, after per-item bundle discounts and free-promo
 * handling.
 */
export function calculatePrices(cart) {
  let savingsNum = 0;
  let subTotalNum = 0;

  if (cart) {
    cart?.lines.map((item) => {
      const { subtotal, savings } = getLineItemCostAndSavings(item);
      subTotalNum += subtotal;
      savingsNum += savings;
    });
    return {
      subtotal: subTotalNum,
      savings: savingsNum
    };
  }

  return {
    subtotal: 0,
    savings: 0
  };
}

export function getLineItemCostAndSavings(item) {
  const isFreePromo =
    item.attributes?.find((attr) => attr.key.includes('promoType'))?.value ===
    'free';

  if (isFreePromo) {
    return { subtotal: 0, savings: 0 };
  }

  const bundleDiscountAttr = item.attributes?.find((attr) =>
    attr.key.includes('bundleDiscountAmount')
  );

  let bundleDiscount = bundleDiscountAttr?.value
    ? parseFloat(bundleDiscountAttr.value)
    : 0;

  const price = parseFloat(item.merchandise.price.amount);
  const compareAtPrice = parseFloat(
    item.merchandise.compareAtPrice?.amount || price
  );

  // Validate that stored discount
  if (bundleDiscount < 0) {
    bundleDiscount = 0;
  } else if (bundleDiscount > price) {
    bundleDiscount = price;
  }

  const finalPrice = price - bundleDiscount;
  const quantity = item.quantity;

  const itemSubtotal = finalPrice * quantity;
  let itemSavings = 0;

  if (price < compareAtPrice) {
    itemSavings = (compareAtPrice - finalPrice) * quantity;
  }

  return { subtotal: itemSubtotal, savings: itemSavings };
}

export function calculateItemCost(quantity, price) {
  return (Number(price) * quantity).toString();
}

export function totalsDisplayPrice(num) {
  // Convert string to number if it's a valid numeric string
  if (typeof num === 'string' && !isNaN(Number(num))) {
    num = Number(num);
  }

  if (isNaN(num) || num == null) {
    // Return a fallback value of '0.00' if the input is invalid
    return '0.00';
  }

  if (Number.isInteger(num)) {
    // If the number is whole, show without decimal places
    return num.toLocaleString('en-US');
  } else {
    // If the number has decimals, show two decimal places
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
}
